<template>
  <div class="nav-item">
    <template>
      <router-link v-if="path" :to="linkHref">{{ name }}</router-link>
      <span v-else :class="{ active: active }">{{ name }}</span>
    </template>
    <span class="separator" v-if="!active">></span>
  </div>
</template>

<script>
export default {
  name: 'NavItem',
  props: {
    name: {
      type: String,
      default: '',
    },
    path: {
      type: String,
      default: '',
    },
    query: {
      type: Object,
      default: () => {},
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    linkHref() {
      return {
        path: this.path,
        query: this.query,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.nav-item {
  display: inline;
  font-size: 16px;
  line-height: 20px;
  color: #666;
  a {
    color: #666;
    text-decoration: none;
  }
  span.active,
  a:hover {
    color: $mainColor;
  }
  .separator {
    margin: 0 5px;
  }
}
</style>
